import { useQuery, QueryResult } from '@apollo/client'
import { CompanySettingsPyramidsQuery, CompanySettingsPyramidsQueryVariables, Country } from '../../types'
import { COMPANY_SETTINGS_PYRAMIDS } from './CompanySettingsQueries'

export const useCompanySettingsPyramids = (
  companyId: string,
  country: Country,
): QueryResult<CompanySettingsPyramidsQuery, CompanySettingsPyramidsQueryVariables> => {
  return useQuery<CompanySettingsPyramidsQuery, CompanySettingsPyramidsQueryVariables>(COMPANY_SETTINGS_PYRAMIDS, {
    variables: { companyId, country },
  })
}
